import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty, keys, minBy, pick, values} from 'lodash';

// FIXME: using my own Money library, not good.
import Money from '../../../../lib/Money';
import FreeShippingIndicator from "../../FreeShippingIndicator";

// FIXME: not camelized

export default function CartPriceDisplay({
  product,
  matchingProducts,
  products
}) {
  //alert(JSON.stringify(matchingProducts, null, 2))
  if (isEmpty(product))
    product = selectCheapestProduct({matchingProducts, products});

  let cents = product?.regularPriceCents;

  if (isNaN(cents)) return null;

  let dollars = new Money(cents);

  return (
    <div className="text-brand-primary lg:h-14">
      <div className="text-2xl">{dollars.toString()}</div>
      <FreeShippingIndicator priceCents={cents} className="subtitle"/>
    </div>
  );
}


function selectCheapestProduct({matchingProducts, products}) {
  if (!matchingProducts || !products)
    return null;

  let goodProds = values(pick(products, keys(matchingProducts)));
  // goodProds = goodProds.filter((p) => p.regularPriceCents);
  return minBy(goodProds, p => (p.regularPriceCents || 999999));
}

CartPriceDisplay.propTypes = {
  application: PropTypes.object,
  product: PropTypes.object,
  matchingProducts: PropTypes.object,
  products: PropTypes.object
}
